import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const VALID_PAGE_SIZES = [10, 25, 50, 100, 250, 500];

export default function PageSizeSelect({
    setPageSize,
    page,
    pageIndex,
    pageSize,
    recalculatePagination,
    totalRecords,
    isTruncated = false,
    storageKey = "",
}) {
    const { pathname } = useLocation();
    const key = storageKey || pathname;

    // Check for a saved table page size in localStorage and use it if possible
    useEffect(() => {
        const savedPageSize = localStorage.getItem(`${key}TablePageSize`);
        if (savedPageSize && VALID_PAGE_SIZES.includes(Number(savedPageSize))) {
            const newPageSize = Number(savedPageSize);
            setPageSize(newPageSize);
        }
    }, [key, setPageSize]);

    function handleChange(e) {
        localStorage.setItem(`${key}TablePageSize`, e.target.value);
        const newPageSize = e.target.value;
        setPageSize(newPageSize);
        recalculatePagination(newPageSize, pageIndex);
    }

    const styles = {
        select: {
            width: "50px",
            marginInline: "5px",
        },
    };

    return (
        <div>
            Showing items {pageIndex * pageSize + 1} to{" "}
            {pageIndex * pageSize + page.length} of {totalRecords}
            {isTruncated ? "+" : ""}
            <div>
                Display
                <select
                    style={styles.select}
                    value={pageSize}
                    onChange={handleChange}
                >
                    {VALID_PAGE_SIZES.map((pageSize) => (
                        <option key={pageSize} value={pageSize}>
                            {pageSize}
                        </option>
                    ))}
                </select>
                items per page
            </div>
        </div>
    );
}
